import { useCustomMutation } from "@/hooks/use-graphql-client";

import { RoomPriceRankDailyStatusUpdate_RoomPriceRankPage_Mutation } from "./mutation";

export const useUpdateRoomPriceRankDailyStatus = () => {
	const { mutationFunc } = useCustomMutation(RoomPriceRankDailyStatusUpdate_RoomPriceRankPage_Mutation);

	return {
		mutationFunc,
	};
};
